import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import RemovedProductsList from '../../modules/removed-products-confirmation/RemovedProductsList'

const RemovedProductsPage: React.FC = () => {
  const {formatMessage} = useIntl()
  return (
    <>
      <PageTitle>{formatMessage({id: 'MENU.REMOVED_PRODUCTS'})}</PageTitle>
      <RemovedProductsList />
    </>
  )
}

export default RemovedProductsPage



